import { Component, Inject, OnInit } from '@angular/core';
import { CDSMask } from '@app/utils/cds-mask';
import { ActivatedRoute, Router } from '@angular/router';
import { MeAvise } from '@app/models/me-avise';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { MeAviseService } from '@app/services/meavise.service';

@Component({
  selector: 'app-me-avise-transferencia',
  templateUrl: './me-avise-transferencia.component.html'
})
export class MeAviseTransferenciaComponent implements OnInit {

  lstUsuarios: IdDescricao[];
  cdsMask: CDSMask = new CDSMask();
  meAvise: MeAvise = new MeAvise();

  data: string;
  prazo: string;
  prazoInterno: string;
  usuarioDestinoId: number;
  bsModalRef: BsModalRef;
  id: number = undefined;

  permitidoVisualizar: boolean = false;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _consultasService: ConsultasService,
    private _modalService: BsModalService,
    private _meAviseService: MeAviseService,
    @Inject(ToastrService) public toastr: ToastrService
  ) {
  }

  ngOnInit() {

    this._route.params.subscribe((params: any) => {
      this.id = params['id'];

      if (!this.id) {
        this._router.navigate(['./dashboard']);
      }

      this.obterMeAvise();
    });

    this._consultasService.consultar('USUARIO').toPromise().then(data => this.lstUsuarios = data);
    this.obterPermissao();

  }

  public transferir() {
    this.bsModalRef = this._modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente transferir?';
    this.bsModalRef.content.confirmar = () => {
      this._meAviseService.transferir(this.meAvise.Id, this.usuarioDestinoId, this.data, this.prazo, this.prazoInterno).toPromise().then(
        () => {
          this.toastr.success('Transferência Realizada', 'Sucesso');
          this.obterMeAvise();
        },
        data => data.error.errors.forEach( itemErro => this.toastr.error(itemErro, 'Erro')));
    };
  }

  obterMeAvise() {
    this._meAviseService.ObterMeAvisePorIdComUsuarioCriacao(this.id).toPromise().then(
      (data: MeAvise) => {
        this.meAvise = data;
        this.data = this.meAvise.Data.split('T')[0];
        this.prazo = this.meAvise.Prazo?.split('T')[0];
        this.prazoInterno = this.meAvise.PrazoInterno?.split('T')[0];
        this.usuarioDestinoId = this.meAvise.UsuarioAtualId;
      }
    );
  }

  realizar(meAviseId: number) {
    this.bsModalRef = this._modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente marcar como realizado?';
    this.bsModalRef.content.confirmar = () => {
      this._meAviseService.realizar(meAviseId).toPromise().then(
        () => { this.retornaCaminho(); },
        data => this.toastr.error(data.errors[0]));
    };
  }

  retornaCaminho() {
    let tipo = '';
    if (this.meAvise.TipoMovimentacaoId === 1)
      tipo = 'administrativa';
    else if (this.meAvise.TipoMovimentacaoId === 2)
      tipo = 'execucao-provisoria';
    else if (this.meAvise.TipoMovimentacaoId === 3)
      tipo = 'judicial';
    
      this._router.navigate(['./processos/processo/', this.meAvise.ProcessoId, 'mov', tipo]);
  }

  private obterPermissao() {
    this._meAviseService.obterPermissaoVisualizacaoPrazo()
      .toPromise().then((data: boolean) => {
        this.permitidoVisualizar = data;
    });
  }

}
